import { settings } from 'src/app/settings';
import { LoyaltyBadgeType } from 'src/app/shared/components/loyalty-badge/types/loyalty-badge.type';

export enum LoyaltyBadgeNameEnum {
  SUPERSTAR = 'Superstar',
  NEW = 'New',
}

export const LOYALTY_BADGES: Record<string, LoyaltyBadgeType> = {
  [LoyaltyBadgeNameEnum.SUPERSTAR]: {
    name: LoyaltyBadgeNameEnum.SUPERSTAR,
    icon: 'assets/loyalty-badges/superstar.svg',
    altText: 'Superstar Icon',
    color: 'purple-400',
    ariaLabel: 'Superstar Badge',
  },
  [LoyaltyBadgeNameEnum.NEW]: {
    name: LoyaltyBadgeNameEnum.NEW,
    color: 'green-500',
    ariaLabel: 'New Badge',
  },
} as const;

export const LEARN_MORE_EXTERNAL_LINK = `https://${settings.brand.domain}/help_centre/mable-badges/` as const;
